/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({"data":{"categories":{"cardinal":["other"],"ordinal":["other"]},"fn":function(num, isOrdinal, exponent = 0) {
    return "other";
}},"locale":"dz"})
} else {
  (globalThis.__FORMATJS_PLURALRULES_DATA__ = globalThis.__FORMATJS_PLURALRULES_DATA__ || []).push({"data":{"categories":{"cardinal":["other"],"ordinal":["other"]},"fn":function(num, isOrdinal, exponent = 0) {
    return "other";
}},"locale":"dz"})
}
